// Типы блокировок пользователя — синхронизировано с backend-monorepo `LockTypeEnum`.
export enum LockTypeEnum {
  LOCKED = 'locked',
  REFERRAL = 'referral',
  DEPOSIT = 'deposit',
  PAYOUT = 'payout',
  EXP = 'exp',
  AUTO = 'auto',
  PERMANENT = 'permanent',
  PROMOTION = 'promotion',
  RAFFLE = 'raffle',
  SEASON = 'season',
  MARKET = 'market',
  SHADOW = 'shadow',
  BET = 'bet',
}

export enum LockActorTypeEnum {
  ADMIN = 'admin',
  SYSTEM = 'system',
  AUTO = 'auto',
  SELF = 'self',
}

export enum LockSourceEnum {
  ADMIN_PANEL = 'admin-panel',
  USER_STATS = 'user-stats',
  EXPERIENCE = 'experience',
}

export enum LockActionEnum {
  LOCK = 'lock',
  UNLOCK = 'unlock',
}

export interface IUpdateUserLockItem {
  type: LockTypeEnum;
  isActive: boolean;
  reason?: string;
  // Срок действия (ISO) — по истечении лок становится неактивным; null/нет — бессрочно.
  expiresAt?: string | null;
}

export interface IUserLock {
  type: LockTypeEnum;
  reason: string | null;
  actorType: LockActorTypeEnum;
  actorId: number | null;
  source: LockSourceEnum | null;
  expiresAt: string | null;
  createdAt: string;
}

export interface IUserLocks {
  userId: number;
  isUserLocked: boolean;
  locks: IUserLock[];
}

export interface IUserLockHistory {
  id: number;
  userId: number;
  type: LockTypeEnum;
  action: LockActionEnum;
  reason: string | null;
  actorType: LockActorTypeEnum;
  actorId: number | null;
  source: LockSourceEnum | null;
  createdAt: string;
}

export interface IUserLockHistoryMetadata {
  history: IUserLockHistory[];
  metadata: { amount?: number; limit?: number; offset?: number };
}

// Метаданные типа: подпись + описание «что лок делает с юзером» (для ?-тултипа).
export const LOCK_TYPE_META: Record<
  LockTypeEnum,
  { label: string; description: string }
> = {
  [LockTypeEnum.LOCKED]: {
    label: 'Основная блокировка',
    description:
      'Отключает начисления рефералу, вывод предметов, активацию промокодов, ставки в играх.',
  },
  [LockTypeEnum.PERMANENT]: {
    label: 'Перманентная блокировка',
    description: 'Полностью отключает доступ ко всем функциям сайта.',
  },
  [LockTypeEnum.PAYOUT]: {
    label: 'Блокировка выводов',
    description: 'Запрещает все виды вывода — через платёжные системы и маркет.',
  },
  [LockTypeEnum.DEPOSIT]: {
    label: 'Блокировка пополнений',
    description: 'Пользователь не может вносить средства на платформу.',
  },
  [LockTypeEnum.REFERRAL]: {
    label: 'Реферальная блокировка',
    description:
      'Пользователь не участвует в реферальной программе и не получает бонусы по промокодам.',
  },
  [LockTypeEnum.EXP]: {
    label: 'Блокировка XP',
    description: 'Отключает начисление опыта (XP).',
  },
  [LockTypeEnum.MARKET]: {
    label: 'Блокировка маркета',
    description: 'Отключает доступ к маркету (покупка китов).',
  },
  [LockTypeEnum.RAFFLE]: {
    label: 'Блокировка раффлов',
    description:
      'Останавливает зачёт новых условий раффлов и увеличение их веса. Запрещает внесение билетов и монет, а также вступление в раффлы без условий. Старые участия и получение заработанных наград сохраняются.',
  },
  [LockTypeEnum.SEASON]: {
    label: 'Блокировка сезонных квестов',
    description:
      'Останавливает начисление нового прогресса сезонных квестов, включая cashback. Накопленные прогресс и очки, а также получение заработанных наград сохраняются. На раффлы не влияет.',
  },
  [LockTypeEnum.BET]: {
    label: 'Блокировка ставок',
    description: 'Запрещает делать ставки в спортбуке.',
  },
  [LockTypeEnum.PROMOTION]: {
    label: 'Стримерская блокировка',
    description: 'Аналог основной блокировки, применяется к стримерам.',
  },
  [LockTypeEnum.AUTO]: {
    label: 'Автоблокировка',
    description: 'Выставляется системой автоматически при подозрительной активности.',
  },
  [LockTypeEnum.SHADOW]: {
    label: 'Теневая блокировка',
    description:
      'Ограничивает вывод денег и скинов; пользователь не уведомляется о блокировке.',
  },
};

// Порядок отображения локов на странице.
// DEPOSIT остаётся скрытым: в новом бэке нет проверки, только зеркало в legacy.
// RAFFLE и SEASON управляют зачётом новых условий в соответствующих сервисах.
export const LOCK_TYPE_ORDER: LockTypeEnum[] = [
  LockTypeEnum.LOCKED,
  LockTypeEnum.PERMANENT,
  LockTypeEnum.PAYOUT,
  LockTypeEnum.REFERRAL,
  LockTypeEnum.EXP,
  LockTypeEnum.SEASON,
  LockTypeEnum.RAFFLE,
  LockTypeEnum.MARKET,
  LockTypeEnum.BET,
  LockTypeEnum.PROMOTION,
  LockTypeEnum.AUTO,
  LockTypeEnum.SHADOW,
];
